import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { User } from 'types/user';
import { isWorkoutsActive } from 'helpers/workoutsHelper';

type Props = {
  children: React.ReactNode;
};

function EnsureWorkoutsActive({ children }: Props) {
  const user = useSelector<any, User>((store) => store.rootReducer.user);

  if (!isWorkoutsActive(user)) {
    return <Redirect to="/program" />;
  }
  return <>{children}</>;
}

export default EnsureWorkoutsActive;
